import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureDashboardReporting
export interface IFeatureDashboardReporting extends IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_DASHBOARD_REPORTING_DEFAULT
export const _FEATURE_DASHBOARD_REPORTING_DEFAULT: Readonly<IFeatureDashboardReporting & Object> = {
  displayText: NavigationPageEnumHumanReadable.DashboardReporting,
  feature: NavigationPageEnum.DashboardReporting,
  ref: SettingsReferenceEnum.undefined,
  standalone: false,
};
//#endregion